module.exports = __webpack_public_path__ + "static/media/followers-icon.1ac6cf30.svg";